import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { isCurrentSession } from '../../filters/schedule/isCurrentSession';
import { sortBy } from 'lodash';

export function useSessionsInProgress(eventId, { filter, sortBy: sortByFunction = ['start_utc', 'order'], count } = {}) {
    const selectSchedule = useMemo(() => (state) => state.events[eventId]?.schedule?.all, [eventId]),
        sessions = useSelector(selectSchedule) ?? [];

    return useMemo(() => {
        let result = sessions.filter(isCurrentSession);

        if (filter) result = result.filter(filter);
        if (sortByFunction) result = sortBy(result, sortByFunction);
        if (count) result = result.slice(0, count);

        return result;
    }, [sessions, filter, sortBy, count]);
}
